/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-i18n/
 */
import { __ } from '@wordpress/i18n';

/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-block-editor/#useblockprops
 */
import { useBlockProps } from '@wordpress/block-editor';

/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * Those files can contain any CSS code that gets applied to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import './editor.scss';

/**
 * The edit function describes the structure of your block in the context of the
 * editor. This represents what the editor will render when the block is used.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#edit
 *
 * @return {WPElement} Element to render.
 */

import { Fragment, useState } from '@wordpress/element';
import { InspectorControls, PanelColorSettings, BlockControls } from '@wordpress/block-editor';
import { PanelBody, ToggleControl, TextControl, __experimentalBorderControl as BorderControl, RangeControl  } from '@wordpress/components';
import ServerSideRender from '@wordpress/server-side-render';

export default function Edit( props ) {
	const { attributes, setAttributes } = props;
	const { showInput, showTripType, showLocation, buttonBackgroundColor, buttonTextColor, searchButtonLabel, searchBorderRadius, inputBorderRadius, inputBorder } = attributes;
	return (
		<div { ...useBlockProps() }>
			<Fragment>
				<InspectorControls>
					<PanelBody title={ __( 'Trip Search Options', 'wp-travel-blocks' ) } >
						<ToggleControl
							label={ __( 'Show Input', 'wp-travel-blocks' ) }
							checked={ showInput }
							onChange={ () => setAttributes( { showInput: ! showInput } ) }
						/>
						<ToggleControl
							label={ __( 'Show Trip Type', 'wp-travel-blocks' ) }
							checked={ showTripType }
							onChange={ () => setAttributes( { showTripType: ! showTripType } ) }
						/>
						<ToggleControl
							label={ __( 'Show Location', 'wp-travel-blocks' ) }
							checked={ showLocation }
							onChange={ () => setAttributes( { showLocation: ! showLocation } ) }
						/>
					</PanelBody>
					<PanelBody title={ __( 'Input Options', 'wp-travel-blocks' ) } >
						<BorderControl
							withSlider
							value={ inputBorder }
							label={__("Input Border")}
							onChange={ ( value ) =>{
								setAttributes( { inputBorder: value } )}
							} 
						/>
						<RangeControl
							help={"in Pixels"}
							initialPosition={3}
							label="Radius"
							max={100}
							min={0}
							value={ inputBorderRadius }
							onChange={value => setAttributes({ inputBorderRadius : value }) }
						/>
					</PanelBody>
					<PanelColorSettings
						title={__('Button Color Options', 'wp-travel-blocks')}
						colorSettings={[
							{
								value: buttonBackgroundColor,
								onChange: colorValue => setAttributes({ buttonBackgroundColor: colorValue }),
								label: __( "Background Color", 'wp-travel-blocks' )
							},
							{
								value: buttonTextColor,
								onChange: colorValue => setAttributes({ buttonTextColor: colorValue }),
								label: __( "Text Color", 'wp-travel-blocks' )
							},
						]}
						initialOpen={false}
					/>
					<PanelBody title={ __( 'Button Options', 'wp-travel-blocks' ) } >
						<TextControl
							label={__('Search Button Label', 'wp-travel-blocks')}
							value={ searchButtonLabel }
							onChange={ ( value ) => setAttributes( { searchButtonLabel: value } ) }
						/>
						<RangeControl
							help={"in Pixels"}
							initialPosition={3}
							label="Radius"
							max={100}
							min={0}
							value={ searchBorderRadius }
							onChange={value => setAttributes({ searchBorderRadius : value }) }
						/>
					</PanelBody>
				</InspectorControls>
			</Fragment>
			<ServerSideRender
				block="wp-travel-blocks/trip-search"
				attributes={ props.attributes }
			/>
		</div>
	);
}
